import { render } from "./LikeStats.vue?vue&type=template&id=0ff0546b"
import script from "./LikeStats.vue?vue&type=script&lang=js"
export * from "./LikeStats.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./LikeStats.vue?vue&type=style&index=0&id=0ff0546b&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__